// removed by extract-text-webpack-plugin
module.exports = {"cardSlider":"_3XSjMVcsrDtv6XY5PcJwWM","thumbnail":"IkHPLLxqVRaHRGD94Nh7i","info":"_3_mnPIoTt85_Ib7c6i1n5n","namePoint":"_1ukLP7Ine3oisNj9JpC5KW","point":"_1IijaHVEfWy9y2NFe4OJ8B","name":"_2AuMAn7pmTxB8dKYJUgWCs","address":"_2uij9AAQM87ieh-caAsYUG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/CardSliderMobile.scss
// module id = 1126
// module chunks = 0